import { render } from "./live-chat.vue?vue&type=template&id=60cbdda7&scoped=true"
import script from "./live-chat.vue?vue&type=script&lang=js"
export * from "./live-chat.vue?vue&type=script&lang=js"

import "../../resources/css/settings.scss?vue&type=style&index=0&id=60cbdda7&lang=scss&scoped=true&external"
import "./live-chat.vue?vue&type=style&index=1&id=60cbdda7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cbdda7"]])

export default __exports__